import axios from "axios";

export async function fetchVotePurchases(token, params = {}) {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.search) query.set("search", params.search);
  if (params.status) query.set("status", params.status);
  if (params.competitionId) query.set("competitionId", String(params.competitionId));

  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/getAllVotePurchases?${query.toString()}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return response.data;
}
